module.exports = __webpack_public_path__ + "media/images/icon_btn_mail_yellow-3140ccbe4eb32f9c1a6a652901b01d82.png";